import {CodebookIdStringModel, CodebookModel} from "app/shared/model/shared.model";

export interface AdministrativeUnitViewRow {
  idAdministrativeUnit: number;
  administrativeUnit: string;
  idAuthority: number;
  authority: string;
  affiliations: string;
  address: string;
}

export interface AdministrativeUnitOverviewFilterDto {
  county: CodebookModel[];
  cityMunicipality: CodebookIdStringModel[];
  authority: CodebookModel[];
}

export const initialAdministrativeUnitOverviewFilterDtoValues: AdministrativeUnitOverviewFilterDto = {
  county: [],
  cityMunicipality: [],
  authority: []
};
